import { baseApi } from '@/services/index';

const resource = process.env.VUE_APP_RESOURCE_SIRGPD_INF_FIN;

export default {
  post(payload) {
    return baseApi.post(resource, payload);
  },
};
